import React from "react";
import { Helmet } from "react-helmet";
import {
  Box,
  Paper,
  Container,
  Card,
  Typography,
  TableCell,
  Button,
  Popper,
  MenuList,
  MenuItem, ClickAwayListener,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import DataTable from "../../../../components/DataTable";
import { useAdminRoleContext } from "../../contexts/adminRole.context";

const style = (theme) => ({
  paper: {
    backgroundColor: "#3A4D54",
    color: theme.palette.common.white,
    borderRadius: "4px",
  },
  boxSubmenu: {
    "&::before": {
      content: '""',
      position: "absolute",
      width: "0",
      height: "0",
      top: "8px",
      right: "-15px",
      border: "8px solid",
      borderColor: "transparent transparent transparent",
      borderLeftColor: "#3A4D54",
      zIndex: 1,
    },
  },
  divider: {
    height: "70%",
    backgroundColor: theme.palette.divider,
    margin: theme.spacing(0, 1),
  },
  menuItem: {
    fontSize: "small",
    display: "block",
  },
});

const useStyles = makeStyles(style);

export default function AdminRolesPage({
  adminRoles,
  totalAdminRoles,
  adminRolesPage,
  itemPerPage,
  anchorEl,
  anchorRef,
  handleActionOpen,
  handleAccessRightOpen,
  onPageClick,
  handleItemPerPageChange,
  currentPage,
  onCreateClick,
  canEdit,
  handleClose,
}) {
  const {
    selectedAdminRole,
    setSelectedAdminRole,
    actionOpen,
    setActionOpen,
    isLoading,
  } = useAdminRoleContext();
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <title>Admins | Kood Asia Management Portal</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          paddingTop: 3,
          paddingBottom: 12,
        }}
      >
        <Container maxWidth={false}>
          <Card sx={{ mb: 2 }}>
            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
              <Typography
                variant="h4"
                sx={{
                  padding: 2,
                }}
              >
                Admin Roles
              </Typography>
              {canEdit && (
                <Box mx={2}>
                  <Button onClick={onCreateClick}>
                    <Typography variant="button">Add Admin Roles +</Typography>
                  </Button>
                </Box>
              )}
            </Box>
          </Card>

          <DataTable
            isLoading={isLoading}
            rows={adminRoles}
            rowsPerPage={itemPerPage}
            total={totalAdminRoles}
            page={currentPage}
            renderHeader={() => (
              <>
                <TableCell>Role</TableCell>
                <TableCell>Action</TableCell>
              </>
            )}
            onPageClick={onPageClick}
            handleItemPerPageChange={handleItemPerPageChange}
            renderRow={(row, index) => {
              const actionItems = [
                {
                  label: "Edit",
                  enabled: canEdit && row.name !== 'Master',
                  onClick: () => handleAccessRightOpen(),
                },
              ].filter((e) => e.enabled);

              return (
                <>
                  <TableCell>{row.name}</TableCell>
                  {/* Action button starts here */}
                  <TableCell>
                    {actionItems.length > 0 && (
                      <>
                        <Button
                          onClick={(event) => {
                            handleActionOpen(event);
                            setSelectedAdminRole(row);
                          }}
                        >
                          <MoreHorizIcon />
                        </Button>
                        <Popper
                          open={actionOpen && selectedAdminRole.id === row.id}
                          anchorEl={anchorEl}
                          onClose={() => setActionOpen(false)}
                          placement="left-start"
                          style={{ zIndex: 1 }}
                        >
                          <Box className={classes.boxSubmenu}>
                            <Paper className={classes.paper}>
                              <ClickAwayListener onClickAway={handleClose}>
                                <MenuList>
                                  {actionItems.map((item) => (
                                    <MenuItem
                                      className={classes.menuItem}
                                      key={row}
                                      onClick={(e) => {
                                        item.onClick();
                                      }}
                                    >
                                      {item.label}
                                    </MenuItem>
                                  ))}
                                </MenuList>
                              </ClickAwayListener>
                            </Paper>
                          </Box>
                        </Popper>
                      </>
                    )}
                  </TableCell>
                </>
              );
            }}
          />
        </Container>
      </Box>
    </>
  );
}
